/* eslint-disable */
import { toast } from '@mx/vix';
import { monitor } from './monitor';
import { bridge } from './bridge';
import { env } from './env';
import { setCookie } from '@mx/fsp-mweb-utils';

export function getUrlQuery() {
  const urlQueryMap: any = {}
  const search = location.search
  if (search) {
    const queryArr = search.slice(1).split('&')
    queryArr.forEach((item) => {
      const query = item.split('=')
      urlQueryMap[query[0]] = decodeURIComponent(query[1])
    })
  }
  return urlQueryMap
}

export function reportTTI() {
  try {
    if (!(window as any).alreadyUploadTTI) {
      monitor.sendPoint(20);
      (window as any).alreadyUploadTTI = true;
    }
  } catch (e) {
    throw new Error(e)
  }
}

export function reportEachPageTTI() {
  try {
    if (!(window as any).alreadyUploadPageTTI) {
      monitor.sendPoint(21);
      (window as any).alreadyUploadPageTTI = true;
    }
  } catch (e) {
    throw new Error(e)
  }
}

export function resetDocumentScroll() {
  // 恢复文档滚动
  const top = document.body.style.top;
  document.body.style.overflow = 'auto';
  document.body.style.position = 'static';
  document.documentElement.scrollTop = -parseInt(top);
  document.body.scrollTop = -parseInt(top);
  document.body.style.top = '';
}

export function fixScrollDeep() {
  // 解决ios滚动穿透问题
  const scrollTop = document.scrollingElement && document.scrollingElement.scrollTop || 0;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = -scrollTop + 'px';
}

export function EHShow() {
  if (bridge) {
    bridge.EHShow();
  }
}

// 节流函数
export function throttle(context: any, func: Function, delay: number) {
  let timer: any = null;
  return function () {
    var args = arguments;
    // 重点来了！！！
    // 只有当执行完定时器的时候才会重新走入!timer判断里面
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  }
}

// 获取定位
export async function getLocation() {
  let location = env.commonParams.location;
  try {
    if (location === '0_0' || location === '0.0_0.0') {
      await bridge.checkLocationService();
      try {
        const _res: any = await bridge.getLocation();
        let lat = _res && _res.lat;
        let lng = _res && _res.lng;
        if (typeof (lat) === 'undefined' || typeof (lng) === 'undefined') {
          monitor.captureMessage(
            {
              name: '【定位信息为空】',
              msg: JSON.stringify(_res)
            },
            {
              level: 'error'
            }
          );
          lat = '0';
          lng = '0';
        }
        location = `${lat}_${lng}`;
      } catch (err) {
        monitor.captureMessage(
          {
            name: '【获取定位失败】',
            msg: JSON.stringify(err)
          },
          {
            level: 'error'
          }
        );
      }
    }
  } catch (err) {
    toast.show('text', '获取定位信息失败，请打开定位权限');
    monitor.captureMessage(
      {
        name: '【未开启定位权限】',
        msg: JSON.stringify(err)
      },
      {
        level: 'warn'
      }
    );
    throw err;
  }
  return location;
}

// 跳转的公共方法
export function urlAddParam(url: string, param: any) {
  const baseUrl = url.split('#')[0]; // 获取基础URL，即.html之前的部分
  const hash = url.split('#')[1] || ''; // 获取hash部分，即.html之后的部分

  // 判断是否已经有查询参数
  const hasQuery = baseUrl.includes('?');

  // 使用reduce拼接参数
  const queryString = Object.keys(param).reduce((acc, key, index) => {
    const prefix = index === 0 && !hasQuery ? '?' : '&'; // 如果是第一个参数且url中没有查询参数，则添加?，否则添加&
    return `${acc}${prefix}${key}=${param[key]}`;
  }, '');

  // 拼接最终的URL
  url = `${baseUrl}${queryString}${hash ? `#${hash}` : ''}`;
  return url;
}

export function bocLogin() {
  bridge.bocBridge('getBocCustomerAllInfo', { merId: getUrlQuery()?.merId || 10610 }, (data) => {
    const config = {
      risk_platform: 3,
      risk_partner: 821,
      risk_app: 216,
      thirdType: 'mt_pay_bank_of_china',
      // state可选字段，具体需不需要请联系haojiakang
      state: {
        client_id: getUrlQuery()?.merId || '10610', // 第三方授权分配的client_id
      },
      accessTokensJson: JSON.parse(data?.cipherText),
      env: env?.pgyEnv === 'test' ? 'test' : '', // 泳道环境
      componentId: 'authLoginComp',
      isMobile: true,
      allowH5guard: true,
      uuid: '',
      // uiConfig可以不配置，默认展示如上图
      uiConfig: {
        extraClass: '',
        logo: {
          img: 'https://p0.meituan.net/travelcube/d8ebb44535845a44e183929eaba1cb0724896.png',
          style: ''
        },
        loginBtn: {
          text: '联合登录',
          style: ''
        },
        showProtocol: false, // 是否展示协议
        protocolList: []
      }
    };

    // 事件回调监听 不需要的可以不写
    (window as any).authLoginComp.session.on('compInited', () => {
      console.log('登录组件初始化完成');
      monitor.captureMessage(
        {
          name: '【双端登录-初始化完成】',
          msg: ''
        },
        {
          level: 'info'
        }
      );
    });
    (window as any).authLoginComp.session.on('authLoginClick', () => {
      console.log('点击联合登录按钮');
    });
    (window as any).authLoginComp.session.on('getAuthTokenFail', (error: any) => {
      monitor.captureMessage(
        {
          name: '【双端登录-登录授权申请接口返回错误】',
          msg: JSON.stringify(error)
        },
        {
          level: 'error'
        }
      );
      console.log('登录授权申请接口返回错误信息: ', error); // 此事件会在登录授权接口返回error时触发，比如风控下发一次验证/二次验证/账号异常等，此时组件也会触发相应的yoda验证流程或者文案提示，业务方可如需监听
    });
    (window as any).authLoginComp.session.on('loginComplete', (info: any) => {
      console.log(JSON.stringify(info));
      if (info.token) {
        try {
          setCookie('userId', info.userId, location.hostname);
        } catch (error) {
          console.log(error);
        }
        window.location.href = urlAddParam(window.location.href, { token: info.token, userId: info.userId });
        return;
      } 
      monitor.captureMessage(
        {
          name: '【双端登录-登录失败】',
          msg: ''
        },
        {
          level: 'error'
        }
      );
      toast.show('text', '登录失败，请稍后重试');
    });
    //初始化组件
    (window as any).authLoginComp.init(config, 'useAccessToken');
  });
}
